import React from 'react'
import PropTypes from 'prop-types'

import Carousel from 'lib/components/carousel'

const PressMobile = ({ languageUrl, languageUrlSwitchForPress }) => {
  return (
    <Carousel
      containerProps={{
        className: 'container-slider only-responsive-flex'
      }}
      innerProps={{
        className: 'container-slider-inner'
      }}
      autoplayDelay={1500}
      speed={500}
      autoplay
      infinite
      easing={'ease-in'}
      disableSwipeByMouse
      disableSwipeByTouch
      preventScrollOnSwipe
      centerMode
      itemsToShow={4}
      forwardBtnProps={{
        show: false
      }}
      backwardBtnProps={{
        show: false
      }}
      itemsListProps={{
        className: 'items-list'
      }}
      dotsNav={{
        show: true,
        itemBtnProps: {
          className: 'item-button'
        },
        activeItemBtnProps: {
          className: 'active-item-button'
        },
        containerProps: {
          className: 'dots-nav-container'
        }
      }}
    >
      {languageUrlSwitchForPress(languageUrl).map(pressSVG => (
        <div key={pressSVG.index} className='press-svg-container'>
          <img src={pressSVG.src} alt={pressSVG.alt} width={pressSVG.width} height={pressSVG.height} />
        </div>
      ))}
    </Carousel>
  )
}

PressMobile.propTypes = {
  languageUrl: PropTypes.string,
  languageUrlSwitchForPress: PropTypes.func
}

export default PressMobile
